import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';
import { DataService } from "../../../services/data.service";
import { event } from 'jquery';
declare var google;
@Component({
  selector: 'adf-dependent-details-form',
  templateUrl: 'dependent-details.html',
  providers: [EnvDataService]
})
export class DependentDetails implements OnInit {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();

  slideTwoForm: FormGroup;
  primaryData:FormGroup;
  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  public change_log_string: any;
  public dependents_family_details: any;
  public do_you_have_children_yes_or_no;
  public how_many_children_number;
  public showPrimaryApplicantFamily = 1;
  public showAdditionalFamily = -1;

  public setflag = 1;

  public validation_messages = {
    'gender': [
      { type: 'required', message: 'Gender is required.' }
    ],
    'current_marital_status': [
      { type: 'required', message: 'Merital status is required.' }
    ],
    'do_you_have_children': [
      { type: 'required', message: 'Do you have children?' }
    ],
    'how_many_children': [
      { type: 'required', message: 'Enter How many dependents do you have under the age of 18?' }
    ],
    'first_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'second_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'third_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fourth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'fifth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],
    'sixth_child_age': [
      { type: 'required', message: 'Enter Child Age.' }
    ],

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];
    this.dependents_family_details = '';

    this.slideTwoForm = formBuilder.group({
      gender: ['', Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      current_marital_status: ['', Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      do_you_have_children: ['', Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      how_many_children: [1],
      first_child_age: [null],
      second_child_age: [null],
      third_child_age: [null],
      fourth_child_age: [null],
      fifth_child_age: [null],
      sixth_child_age: [null],
      addFamilyItem: formBuilder.array([]),
      addEmploymentItem:  this.formBuilder.array([]),
    });

    this.primaryData = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addAnotherApplicantItem: this.formBuilder.array([]),
    })

  }
  ngOnInit() {
    this.childrenCount();
  }

  primaryApplicantFamily(event, index){
    this.showPrimaryApplicantFamily = 1;
    this.showAdditionalFamily = -1;
   
  }
  editprimaryApplicantFamily(){
    this.showPrimaryApplicantFamily = 1;
    this.showAdditionalFamily = -1;
   
  }

  familyOfApplicant(event, index){
    this.showPrimaryApplicantFamily = 0;
    this.showAdditionalFamily = index;
    
  }

  familyOfApplicant2(index){
    this.showPrimaryApplicantFamily = 0;
    this.showAdditionalFamily = index;
   
  }

  ngOnChanges() {
   
  }

  getUserData(e){
   
    debugger;
    if(e.contact_details.dependent) {
      this.slideTwoForm.controls.gender.setValue(e.contact_details.dependent.gender);
    this.slideTwoForm.controls.current_marital_status.setValue(e.contact_details.dependent.current_marital_status);
    this.slideTwoForm.controls.do_you_have_children.setValue(e.contact_details.dependent.do_you_have_children);
    this.primaryData.controls.firstname.setValue(e.user_data.firstname);
    this.primaryData.controls.lastname.setValue(e.user_data.lastname);

    if(this.slideTwoForm.value.do_you_have_children == "Yes") {
      //this.do_you_have_children_yes_or_no = 'Yes';
      this.how_many_children_number = e.contact_details.dependent.children_age.length;
      this.slideTwoForm.get('how_many_children').setValue(e.contact_details.dependent.children_age.length);
      e.contact_details.dependent.children_age.forEach((element,index) => {
        if(index == 0) {
          this.slideTwoForm.get('first_child_age').setValue(element.age);
        }
        if(index == 1) {
  
          this.slideTwoForm.get('second_child_age').setValue(element.age);
        }
        if(index == 2) {
      
          this.slideTwoForm.get('third_child_age').setValue(element.age);
        }
        if(index == 3) {
          this.slideTwoForm.get('fourth_child_age').setValue(element.age);
        }
        if(index == 4) {
          this.slideTwoForm.get('fifth_child_age').setValue(element.age);
        }
        if(index == 5) {
          this.slideTwoForm.get('sixth_child_age').setValue(element.age);
        }
      });
    }
    else {

       //debugger;
        //this.slideTwoForm.get('do_you_have_children').setErrors(null);
        this.slideTwoForm.get('first_child_age').setErrors(null);
        this.slideTwoForm.get('first_child_age').setValue('');
        this.slideTwoForm.get('how_many_children').setValue('');
        this.slideTwoForm.get('how_many_children').setErrors(null);
        // this.do_you_have_children_yes_or_no = 'No';
        // this.how_many_children_number = 0;
    }
    }
    else {
      this.primaryData.controls.firstname.setValue(e.user_data.firstname);
      this.primaryData.controls.lastname.setValue(e.user_data.lastname);
    }
    

  }

  addAnotherApplicant() {

    this.formApplicantFamily.push(this.initaddAnotherApplicantFamily());
    this.primaryApplicantdata.push(this.initaddAnotherApplicant2());
  }

  getAdditionalApplicantUserData1(data,index){
    
    const anotherAppilicantFamilyFormGroup=<FormGroup>this.slideTwoForm.controls['addFamilyItem']['controls'][index];
   
    anotherAppilicantFamilyFormGroup.controls.gender.setValue(data.contact_details.dependent.gender);
    anotherAppilicantFamilyFormGroup.controls.current_marital_status.setValue(data.contact_details.dependent.current_marital_status);
    anotherAppilicantFamilyFormGroup.controls.do_you_have_children.setValue(data.contact_details.dependent.do_you_have_children);
  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  get formApplicantFamily() {
    return this.slideTwoForm.get('addFamilyItem') as FormArray;
  }



  childrenCount() {
    let howManyChildren = this.slideTwoForm.get('how_many_children');
    let firstChild = this.slideTwoForm.get('first_child_age');
    let secondChild = this.slideTwoForm.get('second_child_age');
    let thirdChild = this.slideTwoForm.get('third_child_age');
    let forthChild = this.slideTwoForm.get('fourth_child_age');
    let fifthChild = this.slideTwoForm.get('fifth_child_age');
    let sixthChild = this.slideTwoForm.get('sixth_child_age');
    howManyChildren.valueChanges
      .subscribe(child => {
        if (child == 0) {
          secondChild.setValidators(null);
          thirdChild.setValidators(null);
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(null);
        }
        if (child == 1) {
          secondChild.setValidators(null);
          thirdChild.setValidators(null);
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
        }
        if (child == 2) {
          thirdChild.setValidators(null);
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
        }
        if (child == 3) {
          forthChild.setValidators(null);
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
        }
        if (child == 4) {
          fifthChild.setValidators(null);
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
          forthChild.setValidators(Validators.required);
        }
        if (child == 5) {
          sixthChild.setValidators(null);
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
          forthChild.setValidators(Validators.required);
          fifthChild.setValidators(Validators.required);
        }
        if (child == 6) {
          firstChild.setValidators(Validators.required);
          secondChild.setValidators(Validators.required);
          thirdChild.setValidators(Validators.required);
          forthChild.setValidators(Validators.required);
          fifthChild.setValidators(Validators.required);
          sixthChild.setValidators(Validators.required);
        }
        firstChild.updateValueAndValidity();
        secondChild.updateValueAndValidity();
        thirdChild.updateValueAndValidity();
        forthChild.updateValueAndValidity();
        fifthChild.updateValueAndValidity();
        sixthChild.updateValueAndValidity();
      });
 
  }

  changeLog(event, index: any) {

  }
  collectLogData(event, type, index) {
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if (type == 'address_type') {
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if (type == 'street_type') {
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if (type == 'state') {
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if (type == 'country') {
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if (type == 'housing_situation') {
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if (type == 'move_in_date') {
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if (type == 'date_of_birth') {
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
 
  }

  public changeDoYouHaveChild($event, type, index) {
    //debugger;
    if (index == 'main') {
      this.do_you_have_children_yes_or_no = $event;
      if($event == 'No') {
        this.slideTwoForm.get('first_child_age').setErrors(null);
        this.slideTwoForm.get('first_child_age').setValue('');
        this.slideTwoForm.get('how_many_children').setValue('');
      }
      else {
        this.slideTwoForm.get('how_many_children').setValue(1);
         this.changeHowManyChildren({_value:'1'}, 'do_you_have_children', 'main');

      }
      
    } else {
      this.setSecondaryChilderValue(index);
    }

  
    if ($event == undefined) {
      return false;
    }
    this.new_val = $event;
    this.old_val = '';
    var property = '';
    if (index == 'main') {
      if (type == 'do_you_have_children') {
        this.old_val = (this.applicant_details.do_you_have_children == undefined) ? '' : this.applicant_details.do_you_have_children;
        property = 'Do You Have Children';
      }
    }
    if (this.new_val != this.old_val) {
     
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  setSecondaryChilderValue(index) {
    debugger;
    let hasChild = this.formApplicantFamily.controls[index].get('do_you_have_children').value;
    let howManyChildren = this.formApplicantFamily.controls[index].get('how_many_children');
    let firstChild = this.formApplicantFamily.controls[index].get('first_child_age');
    let secondChild = this.formApplicantFamily.controls[index].get('second_child_age');
    let thirdChild = this.formApplicantFamily.controls[index].get('third_child_age');
    let forthChild = this.formApplicantFamily.controls[index].get('fourth_child_age');
    let fifthChild = this.formApplicantFamily.controls[index].get('fifth_child_age');
    let sixthChild = this.formApplicantFamily.controls[index].get('sixth_child_age');
    if (hasChild == 'No') {
      howManyChildren.setValidators(null);
      firstChild.setValidators(null);
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
    }
    if (hasChild == 'Yes') {
      howManyChildren.setValue(1);
      howManyChildren.setValidators([Validators.required]);
      firstChild.setValidators([Validators.required]);
      firstChild.setValue(null);
      secondChild.setValue(null);
      thirdChild.setValue(null);
      forthChild.setValue(null);
      fifthChild.setValue(null);
      sixthChild.setValue(null);
    }
    howManyChildren.updateValueAndValidity();
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

  
  }

  codeInput(event) {
    // debugger;
    // console.log('key press');
    // console.log(this.slideTwoForm);
    // console.log(event.target.value);
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }

  }



  public changeHowManyChildren($event, type, index) {
    debugger;
    console.log(this.slideTwoForm);
    if (index == 'main') {
      this.how_many_children_number = $event._value;
      let data=this.slideTwoForm.get('how_many_children').value;   
      if(data != "")
      {
        if(data === "0")
        {
          this.slideTwoForm.get('how_many_children').setValue("");
          this.slideTwoForm.get('how_many_children').setValidators([Validators.required]);
          this.slideTwoForm.get('how_many_children').updateValueAndValidity();
        }
      }
      else
      {
        this.slideTwoForm.get('how_many_children').setValidators([Validators.required]);
        this.slideTwoForm.get('how_many_children').updateValueAndValidity();
      }
      // let z=this.slideTwoForm.get('do_you_have_children').value;
      // if( z == 'No'){
      //   // console.log('before',this.slideTwoForm.get('first_child_age'));
      //   this.slideTwoForm.get('first_child_age').setErrors(null);
      //   this.slideTwoForm.get('how_many_children').setValue("");
      //   this.slideTwoForm.get('first_child_age').setValue("");
      //   // console.log('after',this.slideTwoForm.get('first_child_age'));
      // }
      // if(z == 'Yes')
      // {
      //   if(data == '') {
      //     if(this.setflag == 1) {
      //       this.slideTwoForm.get('how_many_children').setValue(1);
      //       this.setflag = 0;
      //     }
          
      //   }
      //   else if(data == 1) {

      //   }
      //   else {
      //     this.slideTwoForm.get('how_many_children').setValue(data);
      //   }
      // }
      
    } 
    else
     {
      this.secondaryChildrenCount(index);
      let data=(<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('how_many_children').value;
      console.log('*****',data);
      if(data != "")
      {
        if(data === "0")
        {
          (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('how_many_children').setValue("");
        }
      }
    }
 
    this.new_val = $event._value;
    this.old_val = '';
    var property = '';
    if (index == 'main') {
      if (type == 'how_many_children') {
        this.old_val = (this.applicant_details.how_many_children == undefined) ? '' : this.applicant_details.how_many_children;
        property = 'How Many Children';
      }
    }
    if (this.new_val != this.old_val) {
    
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }



  secondaryChildrenCount(index) {
    let child = this.formApplicantFamily.controls[index].get('how_many_children').value;
    let firstChild = this.formApplicantFamily.controls[index].get('first_child_age');
    let secondChild = this.formApplicantFamily.controls[index].get('second_child_age');
    let thirdChild = this.formApplicantFamily.controls[index].get('third_child_age');
    let forthChild = this.formApplicantFamily.controls[index].get('fourth_child_age');
    let fifthChild = this.formApplicantFamily.controls[index].get('fifth_child_age');
    let sixthChild = this.formApplicantFamily.controls[index].get('sixth_child_age');
    if (child == 0) {
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(null);
    }
    if (child == 1) {
      secondChild.setValidators(null);
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
    }
    if (child == 2) {
      thirdChild.setValidators(null);
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
    }
    if (child == 3) {
      forthChild.setValidators(null);
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
    }
    if (child == 4) {
      fifthChild.setValidators(null);
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
    }
    if (child == 5) {
      sixthChild.setValidators(null);
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
      fifthChild.setValidators(Validators.required);
    }
    if (child == 6) {
      firstChild.setValidators(Validators.required);
      secondChild.setValidators(Validators.required);
      thirdChild.setValidators(Validators.required);
      forthChild.setValidators(Validators.required);
      fifthChild.setValidators(Validators.required);
      sixthChild.setValidators(Validators.required);
    }
    firstChild.updateValueAndValidity();
    secondChild.updateValueAndValidity();
    thirdChild.updateValueAndValidity();
    forthChild.updateValueAndValidity();
    fifthChild.updateValueAndValidity();
    sixthChild.updateValueAndValidity();

   
  }

  test() {
   
  }


  
  get formApplicantEmployment() {
    return this.slideTwoForm.get('addEmploymentItem') as FormArray;
  }


  initaddAnotherApplicantFamily() {
    return this.formBuilder.group({
      gender: ['', Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      current_marital_status: ['', Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      do_you_have_children: ['', Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      how_many_children: [1],
      first_child_age: [''],
      second_child_age: [''],
      third_child_age: [''],
      fourth_child_age: [''],
      fifth_child_age: [''],
      sixth_child_age: ['']
    });
  }
  initaddAnotherApplicantFamily2(formObj) {
    return this.formBuilder.group({
      gender: [formObj.gender, Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      current_marital_status: [formObj.current_marital_status, Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      do_you_have_children: [formObj.do_you_have_children, Validators.compose([Validators.required,Validators.maxLength(30), Validators.required])],
      how_many_children: [formObj.how_many_children],
      first_child_age: [''],
      second_child_age: [''],
      third_child_age: [''],
      fourth_child_age: [''],
      fifth_child_age: [''],
      sixth_child_age: ['']
    });
  }

  deleteSecondaryApplicant(index) {
    this.formApplicantFamily.removeAt(index);

  }

  getValue() {
    this.valueChange.emit({dependentDetailFormValue:this.slideTwoForm.value,
      dependentDetailFormIsValid:false,dependentdetailform:this.slideTwoForm});
  }

  populateDataForEdit(data){
    debugger;
    let primary_dependentdetail:any;
    let primary_additional_dependentdetails:any=[];
    if(data.length > 0){
      for(var i=0;i<data.length;i++)
      {
   
        if(data[i].type == 'primary'){
          primary_dependentdetail=data[i].contact_details.dependent;
        }
        else{
          if(data[i].contact_details.dependent) {
            primary_additional_dependentdetails.push(data[i].contact_details.dependent)
          }
          else {
            this.formApplicantFamily.push(this.initaddAnotherApplicantFamily());
          }
          
          
        }
      }
  }

  if(primary_dependentdetail) {
    if(Object.keys(primary_dependentdetail).length > 0){
      this.slideTwoForm.get('gender').setValue(primary_dependentdetail.gender);
      this.slideTwoForm.get('current_marital_status').setValue(primary_dependentdetail.current_marital_status);
      this.slideTwoForm.get('do_you_have_children').setValue(primary_dependentdetail.do_you_have_children);
      if(this.slideTwoForm.value.do_you_have_children == "Yes") {
        this.do_you_have_children_yes_or_no = 'Yes';
        this.how_many_children_number = primary_dependentdetail.children_age.length;
        if(primary_dependentdetail.children_age.length > 0) {
          this.slideTwoForm.get('how_many_children').setValue(primary_dependentdetail.children_age.length);
        }
        else {
          this.slideTwoForm.get('how_many_children').setValue('');
          //this.slideTwoForm.get('how_many_children').setValue('');
        }
        
        primary_dependentdetail.children_age.forEach((element,index) => {
          if(index == 0) {
            this.slideTwoForm.get('first_child_age').setValue(element.age);
          }
          if(index == 1) {
    
            this.slideTwoForm.get('second_child_age').setValue(element.age);
          }
          if(index == 2) {
        
            this.slideTwoForm.get('third_child_age').setValue(element.age);
          }
          if(index == 3) {
            this.slideTwoForm.get('fourth_child_age').setValue(element.age);
          }
          if(index == 4) {
            this.slideTwoForm.get('fifth_child_age').setValue(element.age);
          }
          if(index == 5) {
            this.slideTwoForm.get('sixth_child_age').setValue(element.age);
          }
        });
      }
      else {
  
         debugger;
          //this.slideTwoForm.get('do_you_have_children').setErrors(null);
          this.slideTwoForm.get('first_child_age').setErrors(null);
          this.slideTwoForm.get('first_child_age').setValue('');
          this.slideTwoForm.get('how_many_children').setValue(0);
          this.do_you_have_children_yes_or_no = 'No';
          this.how_many_children_number = 0;
      }
      
    }
  }
  

  if(primary_additional_dependentdetails.length > 0)
  {
 
    primary_additional_dependentdetails.forEach((element,mainindex)=>{
  
     let z=this.initaddAnotherApplicantFamily2(element);
  
     (<FormArray>this.slideTwoForm.get('addFamilyItem')).push(z);

     

     element.children_age.forEach((item,index) => {
      if(index == 0) {
 
        this.formApplicantFamily.at(mainindex).get("first_child_age").setValue(item.age);
      }
      if(index == 1) {
        this.formApplicantFamily.at(mainindex).get("second_child_age").setValue(item.age);
      }
      if(index == 2) {
    
        this.formApplicantFamily.at(mainindex).get("third_child_age").setValue(item.age);
      }
      if(index == 3) {
        this.formApplicantFamily.at(mainindex).get("fourth_child_age").setValue(item.age);
      }
      if(index == 4) {
        this.formApplicantFamily.at(mainindex).get("fifth_child_age").setValue(item.age);
      }
      if(index == 5) {
        this.formApplicantFamily.at(mainindex).get("sixth_child_age").setValue(item.age);
      }
    });

    let do_you_have_children = this.formApplicantFamily.at(mainindex).get("do_you_have_children").value;

    let howManyChildren = this.formApplicantFamily.at(mainindex).get("how_many_children").value;
    if(do_you_have_children !== 'No') {
      this.formApplicantFamily.at(mainindex).get("how_many_children").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("how_many_children").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("how_many_children").markAsTouched();
    }
    if((do_you_have_children !== 'No') && (howManyChildren  == 1)) {
      this.formApplicantFamily.at(mainindex).get("first_child_age").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("first_child_age").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("first_child_age").markAsTouched();
    }
    if((do_you_have_children !== 'No') && (howManyChildren  == 2)) {
      this.formApplicantFamily.at(mainindex).get("second_child_age").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("second_child_age").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("second_child_age").markAsTouched();
    }
    if((do_you_have_children !== 'No') && (howManyChildren  == 3)) {
      this.formApplicantFamily.at(mainindex).get("third_child_age").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("third_child_age").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("third_child_age").markAsTouched();
    }
    if((do_you_have_children !== 'No') && (howManyChildren  == 4)) {
      this.formApplicantFamily.at(mainindex).get("fourth_child_age").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("fourth_child_age").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("fourth_child_age").markAsTouched();
    }
    if((do_you_have_children !== 'No') && (howManyChildren  == 5)) {
      this.formApplicantFamily.at(mainindex).get("fifth_child_age").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("fifth_child_age").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("fifth_child_age").markAsTouched();
    }
    if((do_you_have_children !== 'No') && (howManyChildren  == 6)) {
      this.formApplicantFamily.at(mainindex).get("sixth_child_age").setValidators([Validators.required])
      this.formApplicantFamily.at(mainindex).get("sixth_child_age").updateValueAndValidity();
      this.formApplicantFamily.at(mainindex).get("sixth_child_age").markAsTouched();
    }

    }) 
  }

  console.log(this.slideTwoForm);
  console.log(this.primaryData);

}

initaddAnotherApplicant2() {
    
  return this.formBuilder.group({
   
    secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
    secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
    secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    deleted: [0],
    uid: [''],
    document_id: ['']
  });
}
initaddAnotherApplicant(adfobj) {
    
  return this.formBuilder.group({
  
    secondary_firstname: [adfobj.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_middlename: [adfobj.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
    secondary_lastname: [adfobj.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_email: [adfobj.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
    secondary_mobile_phone: [adfobj.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_date_of_birth: [adfobj.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
    relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    deleted: [0],
    uid: [''],
    document_id: ['']
  });
}

initaddAnotherApplicant_new(adfobj) {
    
  return this.formBuilder.group({
  
    secondary_firstname: [adfobj.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_middlename: [adfobj.middlename, Validators.compose([Validators.maxLength(30)])],
    secondary_lastname: [adfobj.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_email: [adfobj.email, Validators.compose([Validators.maxLength(100), Validators.required])],
    secondary_mobile_phone: [adfobj.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
    secondary_date_of_birth: [adfobj.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
    relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    deleted: [0],
    uid: [adfobj.uid],
    document_id: ['']
  });
}

get primaryApplicantdata() {
  return this.primaryData.get('addAnotherApplicantItem') as FormArray;
}

setDependentDetails(primaryDetails) {

  this.primaryData.controls.firstname.setValue(primaryDetails.value.firstname);
  this.primaryData.controls.lastname.setValue(primaryDetails.value.lastname);
  
  primaryDetails.value.addAnotherApplicantItem.forEach((element,index) => { 
    if(this.primaryApplicantdata.value[index]) {
      this.primaryApplicantdata.value[index].secondary_firstname = element.secondary_firstname;
      this.primaryApplicantdata.value[index].secondary_lastname = element.secondary_lastname;
      }
      else {
        this.primaryApplicantdata.push(this.initaddAnotherApplicant(element));
      }
  });
}

setAdditionalDetails(data){
// console.log(data);
  data.forEach((element,index) => { 
      if(element.type == "additional") {

          if(this.primaryApplicantdata.value[index]) {
          this.primaryApplicantdata.value[index].secondary_firstname = element.user_data.firstname;
          this.primaryApplicantdata.value[index].secondary_lastname = element.user_data.lastname;
          }
          else {
            this.primaryApplicantdata.push(this.initaddAnotherApplicant_new(element.user_data));
          }
      }
   
  });
}

setAddiDependentDetails(additionalDetail) {

  this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_firstname').setValue(additionalDetail.user_data.firstname);
  this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_lastname').setValue(additionalDetail.user_data.lastname);

  if(additionalDetail.contact_details.dependent) {
    (<FormArray>this.slideTwoForm.get('addFamilyItem')).at(additionalDetail.additional_index).get('current_marital_status').setValue(additionalDetail.contact_details.dependent.current_marital_status);
    (<FormArray>this.slideTwoForm.get('addFamilyItem')).at(additionalDetail.additional_index).get('do_you_have_children').setValue(additionalDetail.contact_details.dependent.do_you_have_children);
    (<FormArray>this.slideTwoForm.get('addFamilyItem')).at(additionalDetail.additional_index).get('how_many_children').setValue(additionalDetail.contact_details.dependent.how_many_children);
    (<FormArray>this.slideTwoForm.get('addFamilyItem')).at(additionalDetail.additional_index).get('gender').setValue(additionalDetail.contact_details.dependent.gender);
  
    if(additionalDetail.contact_details.dependent.do_you_have_children == "Yes") {
      //this.do_you_have_children_yes_or_no = 'Yes';
    additionalDetail.contact_details.dependent.children_age.forEach((item,index) => {
      if(index == 0) {
  
        this.formApplicantFamily.at(additionalDetail.additional_index).get("first_child_age").setValue(item.age);
      }
      if(index == 1) {
        this.formApplicantFamily.at(additionalDetail.additional_index).get("second_child_age").setValue(item.age);
      }
      if(index == 2) {
    
        this.formApplicantFamily.at(additionalDetail.additional_index).get("third_child_age").setValue(item.age);
      }
      if(index == 3) {
        this.formApplicantFamily.at(additionalDetail.additional_index).get("fourth_child_age").setValue(item.age);
      }
      if(index == 4) {
        this.formApplicantFamily.at(additionalDetail.additional_index).get("fifth_child_age").setValue(item.age);
      }
      if(index == 5) {
        this.formApplicantFamily.at(additionalDetail.additional_index).get("sixth_child_age").setValue(item.age);
      }
    });
  }
  else {
  
    debugger;
     //this.slideTwoForm.get('do_you_have_children').setErrors(null);
     this.formApplicantFamily.at(additionalDetail.additional_index).get("first_child_age").setErrors(null);
     this.formApplicantFamily.at(additionalDetail.additional_index).get("first_child_age").setValue('');
     this.formApplicantFamily.at(additionalDetail.additional_index).get('how_many_children').setValue(0);
     this.formApplicantFamily.at(additionalDetail.additional_index).get("how_many_children").setErrors(null);
    //  this.do_you_have_children_yes_or_no = 'No';
    //  this.how_many_children_number = 0;
  }
  }

  

}

onChangeChildAge(event)
{
console.log(this.slideTwoForm);

let howManyChildren=parseInt(this.slideTwoForm.get('how_many_children').value);
if(howManyChildren == 1)
{
  let age1=parseInt(this.slideTwoForm.get('first_child_age').value);
  console.log(age1);
  if(age1 < 0)
  {
    this.slideTwoForm.get('first_child_age').setValue("");
  }
}

if(howManyChildren == 2)
{
  let age1=parseInt(this.slideTwoForm.get('first_child_age').value);
  let age2=parseInt(this.slideTwoForm.get('second_child_age').value);
  if(age1 < 0)
  {
    this.slideTwoForm.get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    this.slideTwoForm.get('second_child_age').setValue("");
  }
}

if(howManyChildren == 3)
{
  let age1=parseInt(this.slideTwoForm.get('first_child_age').value);
  let age2=parseInt(this.slideTwoForm.get('second_child_age').value);
  let age3=parseInt(this.slideTwoForm.get('third_child_age').value);
  if(age1 < 0)
  {
    this.slideTwoForm.get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    this.slideTwoForm.get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    this.slideTwoForm.get('third_child_age').setValue("");
  }
}

if(howManyChildren == 4)
{
  let age1=parseInt(this.slideTwoForm.get('first_child_age').value);
  let age2=parseInt(this.slideTwoForm.get('second_child_age').value);
  let age3=parseInt(this.slideTwoForm.get('third_child_age').value);
  let age4=parseInt(this.slideTwoForm.get('fourth_child_age').value);
  if(age1 < 0)
  {
    this.slideTwoForm.get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    this.slideTwoForm.get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    this.slideTwoForm.get('third_child_age').setValue("");
  }
  if(age4 < 0)
  {
    this.slideTwoForm.get('fourth_child_age').setValue("");
  }
}

if(howManyChildren == 5)
{
  let age1=parseInt(this.slideTwoForm.get('first_child_age').value);
  let age2=parseInt(this.slideTwoForm.get('second_child_age').value);
  let age3=parseInt(this.slideTwoForm.get('third_child_age').value);
  let age4=parseInt(this.slideTwoForm.get('fourth_child_age').value);
  let age5=parseInt(this.slideTwoForm.get('fifth_child_age').value);
  if(age1 < 0)
  {
    this.slideTwoForm.get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    this.slideTwoForm.get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    this.slideTwoForm.get('third_child_age').setValue("");
  }
  if(age4 < 0)
  {
    this.slideTwoForm.get('fourth_child_age').setValue("");
  }
  if(age5 < 0)
  {
    this.slideTwoForm.get('fifth_child_age').setValue("");
  }
}

if(howManyChildren == 6)
{
  let age1=parseInt(this.slideTwoForm.get('first_child_age').value);
  let age2=parseInt(this.slideTwoForm.get('second_child_age').value);
  let age3=parseInt(this.slideTwoForm.get('third_child_age').value);
  let age4=parseInt(this.slideTwoForm.get('fourth_child_age').value);
  let age5=parseInt(this.slideTwoForm.get('fifth_child_age').value);
  let age6=parseInt(this.slideTwoForm.get('sixth_child_age').value);
  if(age1 < 0)
  {
    this.slideTwoForm.get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    this.slideTwoForm.get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    this.slideTwoForm.get('third_child_age').setValue("");
  }
  if(age4 < 0)
  {
    this.slideTwoForm.get('fourth_child_age').setValue("");
  }
  if(age5 < 0)
  {
    this.slideTwoForm.get('fifth_child_age').setValue("");
  }
  if(age6 < 0)
  {
    this.slideTwoForm.get('sixth_child_age').setValue("");
  }
}
}

onChangeChildAgeAdditional(event,index)
{
let howManyChildren=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('how_many_children').value);
if(howManyChildren == 1)
{
  let age1=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').value);
  console.log(age1);
  if(age1 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').setValue("");
  }
}

if(howManyChildren == 2)
{
  let age1=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').value);
  let age2=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').value);
  if(age1 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').setValue("");
  }
}

if(howManyChildren == 3)
{
  let age1=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').value);
  let age2=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').value);
  let age3=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').value);
  if(age1 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').setValue("");
  }
}

if(howManyChildren == 4)
{
  let age1=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').value);
  let age2=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').value);
  let age3=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').value);
  let age4=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fourth_child_age').value);
  if(age1 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').setValue("");
  }
  if(age4 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fourth_child_age').setValue("");
  }
}

if(howManyChildren == 5)
{
  let age1=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').value);
  let age2=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').value);
  let age3=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').value);
  let age4=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fourth_child_age').value);
  let age5=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fifth_child_age').value);
  if(age1 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').setValue("");
  }
  if(age4 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fourth_child_age').setValue("");
  }
  if(age5 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fifth_child_age').setValue("");
  }
}

if(howManyChildren == 6)
{
  let age1=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').value);
  let age2=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').value);
  let age3=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').value);
  let age4=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fourth_child_age').value);
  let age5=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fifth_child_age').value);
  let age6=parseInt((<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('sixth_child_age').value);
  if(age1 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('first_child_age').setValue("");
  }
  if(age2 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('second_child_age').setValue("");
  }
  if(age3 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('third_child_age').setValue("");
  }
  if(age4 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fourth_child_age').setValue("");
  }
  if(age5 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('fifth_child_age').setValue("");
  }
  if(age6 < 0)
  {
    (<FormArray>this.slideTwoForm.get('addFamilyItem'))['controls'][index].get('sixth_child_age').setValue("");
  }
}
}
}



// WEBPACK FOOTER //
// ./src/pages/adf-page/component/dependent-and-family/dependent-details/dependent-details.ts